import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useCurrentClient } from "@/features/clients/hooks/use-clients";
import { QualificationsAPI } from "../api/qualifications";
import type {
  QualificationFormTemplate,
  CreateFormFromTemplateRequest,
} from "../types";

export function useQualificationFormTemplates(
  category?: QualificationFormTemplate["category"],
) {
  const currentClient = useCurrentClient();
  const clientId = currentClient?.client?.id || "";

  return useQuery({
    queryKey: ["qualification-templates", clientId, category],
    queryFn: () => QualificationsAPI.listTemplates(clientId, category),
    enabled: !!clientId,
  });
}

export function useQualificationFormTemplate(templateKey: string) {
  const currentClient = useCurrentClient();
  const clientId = currentClient?.client?.id || "";

  return useQuery({
    queryKey: ["qualification-template", clientId, templateKey],
    queryFn: () => QualificationsAPI.getTemplate(clientId, templateKey),
    enabled: !!clientId && !!templateKey,
  });
}

export function useCreateFormFromTemplate() {
  const currentClient = useCurrentClient();
  const clientId = currentClient?.client?.id || "";
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      templateKey,
      data,
    }: {
      templateKey: string;
      data?: CreateFormFromTemplateRequest;
    }) => QualificationsAPI.createFormFromTemplate(clientId, templateKey, data),
    onSuccess: () => {
      // Invalidate forms cache
      queryClient.invalidateQueries({
        queryKey: ["qualification-forms", clientId],
      });
    },
  });
}
